import React, {useMemo, useState} from 'react';
import {IconButton, MenuItem, TableCell, TableRow} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import {Location} from "@src/Interfaces/Entity/Location";
import {FullWidthTextField} from "@src/Shared/styles";

export interface IPersonPositionItemFields {
    positionId: string;
    locationId: string;
    locked: boolean;
}

export interface IPersonPositionItem {
    itemId: string;
    listId: number;
    fields?: IPersonPositionItemFields;
    initial?: IPersonPositionItemFields;
    touched?: boolean;
    isNew: boolean;
    errors?: any;
}

export interface IPersonPositionItemProps {
    item: IPersonPositionItem;
    onChange: any;
    onRemove: any;
    errors?: any;
    lockInputs?: boolean;
    locations: Array<Location>;
    positions: any;
    takenLocationIds: Array<string>;
    enableAdminSelection: boolean;
    adminPositionId: string;
}

export function PersonPositionItem(props: IPersonPositionItemProps) {

    const [positionId, setPositionId] = useState(props.item.fields.positionId);
    const [locationId, setLocationId] = useState(props.item.fields.locationId);
    const [locked, setLocked] = useState(props.item.fields.locked);
    
    const lockAdminInput = useMemo(() => {
       return (positionId == props.adminPositionId) && !props.enableAdminSelection;
    }, [positionId, props.adminPositionId, props.enableAdminSelection]);
    
    const availableLocations = useMemo(() => {
        return props.locations.filter(x => !props.takenLocationIds.includes(x.id) || locationId == x.id);
    }, [props.takenLocationIds, locationId]);

    function onPositionIdChange(ev: any) {
        setPositionId(ev.target.value);
        props.onChange(props.item.listId, { positionId: ev.target.value, locationId, locked });
    }

    function onLocationIdChange(ev: any) {
        setLocationId(ev.target.value);
        props.onChange(props.item.listId, { positionId, locationId: ev.target.value, locked });
    }

    function onLockedChange(state: boolean) {
        setLocked(state);
        props.onChange(props.item.listId, { positionId, locationId, locked: state });
    }
    
    return (
        <TableRow>
            <TableCell>
                <FullWidthTextField
                    select
                    disabled={props.lockInputs || lockAdminInput}
                    error={!!props.item.errors?.locationId}
                    label={props.item.errors?.locationId}
                    value={props.item.fields.locationId}
                    onChange={(ev: any) => { onLocationIdChange(ev) }}
                    placeholder={"Location"}
                    variant="outlined"
                    size={"small"}
                >
                    { availableLocations?.map((loc: any, i: number) => <MenuItem key={i} value={loc.id}>{loc.name}</MenuItem>)}
                </FullWidthTextField>
            </TableCell>
            <TableCell>
                <FullWidthTextField
                    select
                    disabled={props.lockInputs || !props.item.fields.locationId || lockAdminInput}
                    error={!!props.item.errors?.positionId}
                    label={props.item.errors?.positionId}
                    value={props.item.fields.positionId}
                    onChange={(ev: any) => { onPositionIdChange(ev) }}
                    placeholder={"Position"}
                    variant="outlined"
                    size={"small"}
                >
                    { props.positions?.map((pos: any, i: number) => <MenuItem
                        key={i}
                        value={pos.id}
                        disabled={pos.id == props.adminPositionId && !props.enableAdminSelection}
                    >
                        {pos.name}
                    </MenuItem>)}
                </FullWidthTextField>
            </TableCell>
            { !props.lockInputs && (
                <TableCell style={{ width: 64 }} size={"small"} align={"center"}>
                    <IconButton onClick={() => { props.onRemove(props.item.listId) }} disabled={lockAdminInput}>
                        <DeleteIcon />
                    </IconButton>
                </TableCell>
            )}
        </TableRow>
    )
}

